module.exports = __webpack_public_path__ + "static/media/world-lock.12763b1b.svg";